import { combineReducers } from 'redux';

import * as types from 'modules/devices/actionTypes';
import error from 'modules/global/reducers/generic.error';
import loading from 'modules/global/reducers/generic.loading';

import deviceName from './deviceName';

export default combineReducers({
  deviceName,
  isFetching: loading(types.FETCH_DEVICES_REQUEST),
  isCreating: loading(types.CREATE_DEVICE_REQUEST),
  isDeleting: loading(types.DELETE_DEVICE_REQUEST),
  apiError: error(types.FETCH_DEVICES_REQUEST),
  creationDeviceApiError: error(types.CREATE_DEVICE_REQUEST),
});
